import React from 'react';
import { Link } from 'react-router-dom';

const Support: React.FC = () => {
  return (
    <div className="support-page">
      <h1>Support</h1>
      <div className="support-buttons">
        <Link to="/privacy-policy" className="support-button">
          Privacy Policy
        </Link>
        <Link to="/terms" className="support-button">
          Terms of Service
        </Link>
        <Link to="/real-estate-data-notice" className="support-button">
          Real Estate Data Notice
        </Link>
        <Link to="/ad-partners" className="support-button">
          Advertising Partners
        </Link>
        <a
          href="mailto:nitin@closingtheory.com"
          className="support-button"
        >
          Contact Us
        </a>
      </div>
    </div>
  );
};

export default Support; 